import styled from '@eduzz/houston-styles';

export const Container = styled.div`
  max-height: 20rem;
  overflow-y: auto;
  padding-top: 0.5rem;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.neutralColor.high.medium};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutralColor.high.dark};
    border-radius: ${({ theme }) => theme.border.radius.sm};
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.neutralColor.low.light};
  }
`;
